<template><div><h1 id="_1-ein-und-ausstieg" tabindex="-1"><a class="header-anchor" href="#_1-ein-und-ausstieg"><span>1. Ein- und Ausstieg</span></a></h1>
<h2 id="_1-1-einstieg-ins-programm" tabindex="-1"><a class="header-anchor" href="#_1-1-einstieg-ins-programm"><span>1.1. Einstieg ins Programm</span></a></h2>
<p>Nach dem aufstarten von funtrade erscheint ein Login-Fenster mit den Eingabefeldern Benutzer, Passwort und Verbindung.</p>
<dl>
<dt>Benutzer</dt>
<dd>Benutzerkürzel</dd>
<dt>Passwort</dt>
<dd>Persönliches funtrade Passwort</dd>
<dt>Verbindung</dt>
<dd>Eingerichtete Verbindung (z.B. Testsystem) auswählen</dd>
</dl>
<p>und danach die Taste Login anklicken. Mit der Taste Bearbeiten lassen sich die Verbindungen konfigurieren (siehe unten).</p>
<h2 id="_1-2-konfiguration-verbindungen" tabindex="-1"><a class="header-anchor" href="#_1-2-konfiguration-verbindungen"><span>1.2. Konfiguration Verbindungen</span></a></h2>
<p>In dieser Maske lassen sich die im Login-Fenster angezeigten Verbindungen anlegen, ändern und löschen.</p>
<dl>
<dt>ID</dt>
<dd>beliebige Bezeichnung eingetragen</dd>
<dt>Host</dt>
<dd>Hostname oder die IP-Nummer des Servers mit der ft-Installation</dd>
<dt>Port</dt>
<dd>Portnummer eintragen (nur bei Protokoll http)</dd>
<dt>Protocol</dt>
<dd>Internetprotokoll eintragen (z.B. „https“)</dd>
<dt>Instance</dt>
<dd>Wenn die restlichen Einträge korrekt sind, kann das Feld aktualisiert werden. Dann werden die verfügbaren Instanzen zur Auswahl angezeigt.</dd>
<dt>Path</dt>
<dd>Vorschlag übernehmen
Nach einem Logoff kann mit <code v-pre>Datei → Login</code> (<strong>Ctrl</strong>+<strong>L</strong>) wieder eingeloggt werden ohne funtrade erneut zu starten.</dd>
</dl>
<h2 id="_1-3-ausstieg" tabindex="-1"><a class="header-anchor" href="#_1-3-ausstieg"><span>1.3. Ausstieg</span></a></h2>
<p>Der Ausstieg aus funtrade erfolgt mit <code v-pre>Datei → Logoff</code> (<strong>Ctrl</strong>+<strong>Shift</strong>+<strong>L</strong>).</p>
</div></template>


